module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cb-Db-Ef.ebf8da8d.png";